import React from 'react'
import { Button } from 'react-bootstrap';
import Carousel from 'react-multi-carousel'
import { LuBadgeCheck, } from "react-icons/lu";
import { MdOutlineStarPurple500 } from 'react-icons/md';
import { FaCar, FaHotel, FaQuoteLeft, FaQuoteRight, FaRegSmileBeam } from 'react-icons/fa';
import { BiSupport } from 'react-icons/bi';
import { FaRegCircleUser } from 'react-icons/fa6';
import { ImMobile } from 'react-icons/im';
import { AiOutlineLike } from "react-icons/ai";
import {TbRosetteDiscount } from "react-icons/tb";


const SectionAboutServices = () => {

    const services = [
        { icons: <FaRegSmileBeam color={"#091C00"} size={45} />, title: "Taux de satisfaction client élevé", description: `Louez une voiture chez notre agence de location avec un processus simple et rapide sans perturber votre productivité` },
        { icons: <LuBadgeCheck color={"#091C00"} size={45} />, title: "Large choix de véhicules et de propriétés", description: `Nos voitures sont toujours entretenues en bonne santé et propreté du moteur pour offrir une expérience de conduite plus confortable` },
        { icons: <BiSupport color={"#091C00"} size={45} />, title: "Service client réactif et disponible", description: `Nos voitures sont toujours entretenues en bonne santé et propreté du moteur pour offrir une expérience de conduite plus confortable` },
        { icons: <ImMobile color={"#091C00"} size={45} />, title: "Processus de réservation simplifié", description: `Nos voitures sont toujours entretenues en bonne santé et propreté du moteur pour offrir une expérience de conduite plus confortable` },
        { icons: <TbRosetteDiscount color={"#091C00"} size={45} />, title: "Offres promotionnelles régulières", description: `Nos voitures sont toujours entretenues en bonne santé et propreté du moteur pour offrir une expérience de conduite plus confortable` },
        { icons: <AiOutlineLike color={"#091C00"} size={45} />, title: "Offres promotionnelles régulières", description: `Nos voitures sont toujours entretenues en bonne santé et propreté du moteur pour offrir une expérience de conduite plus confortable` },
    ];

    return (
        <div className="container-fluid" style={{ padding: "100px 0px 100px 0px" }}>

            {/*listes de vehoicule */}
            <div className="container" style={{ padding: "50px 0px 50px 0px" }}>

                <div className="row" style={{ justifyContent: "center" }} >
                    {
                        services.map((item) => {
                            return (
                                <div className="col-md-3 rounded-lg" style={{ border: "1px #42B711 solid", margin: "10px", display: "flex", flexDirection: "column", justifyContent:"center", alignContent: "center", padding: "30px" }}>
                                    <div className="pt-3" style={{ display:"flex", justifyContent:"center" }}>
                                        {item.icons}
                                    </div>
                                    <div className="pt-2 pb-2" style={{ display: "flex", justifyContent: "space-between", }}>
                                        <div>
                                            <h3 className="text-center" style={{ fontSize:"24px", color: "#091C00" }}>{item.title}</h3>
                                        </div>
                                    </div>
                                    <div className="pt-2 pb-2" style={{ display: "flex", justifyContent: "space-between", }}>
                                        <div>
                                            <p className="text-center" style={{fontSize:"16px", color: "#091C00" }}>{item.description}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>

            {/* Bouton ensavoir plus */}
            {/*<div style={{ width: "100%", display: "flex", justifyContent: "center", margin: "30px 0px 0px 0px" }}>
                <Button type="button" style={{ padding: "10px 10px 10px 10px", color: "white", borderRadius: "30px", textAlign: "center", display: "flex", justifyContent: "center" }} variant="dark" className="">
                    <div style={{ display: "flex", justifyContent: "space-between", alignContent: "center" }}>
                        <div className="p-1"><span className="text-center"> Voire plus </span> </div>
                    </div>
                </Button>
            </div> */}

        </div>
    )
}

export default SectionAboutServices
